const publicUrl = process.env.PUBLIC_URL || '';

export const BRAND_NAME = 'Sparkle RFID';
export const BRAND_LOGO_WORDMARK = `${publicUrl}/Logo/Sparkle%20RFID%20svg.svg`;
export const BRAND_LOGO_MARK = `${publicUrl}/Logo/sparkle-logo.png`;
export const BRAND_LOGO_FALLBACK = `${publicUrl}/Logo/logo.png`;
export const BRAND_GOLD = '#C59D5F';
export const BRAND_INK = '#2D2D2D';
